import { z } from "zod";
import toFirestoreSchema from "../utils/toFirestoreSchema";

/**
 * VENUE SCHEMA
 * Represents a venue where book club sessions are held
 */
export const VenueSchema = z.object({
    /** Street address */
    address: z.string().optional().describe("Street address"),

    /** Maximum capacity for events */
    capacity: z.number().int().positive().describe("Maximum attendee capacity"),

    /** Unique venue identifier */
    id: z.string().describe("Unique venue identifier"),

    /** Maximum number of tables */
    maxTableCount: z.number().int().positive().describe("Maximum number of tables"),

    /** Venue name */
    name: z.string().min(1).describe("Venue name"),

    /** Venue website or booking URL */
    websiteUrl: z.string().url().optional().describe("Venue website URL"),
});

export const VenueRecordSchema = toFirestoreSchema(VenueSchema);

// Type export
export type Venue = z.infer<typeof VenueSchema>;
export type VenueRecord = z.infer<typeof VenueRecordSchema>;
